import JacksonvilleHeroSection from "./components/HeroSection";
import JacksonvilleStickyNav from "./components/StickyNav";
import JacksonvilleProcessingTimeSection from "./components/ProcessingTimeSection";
import JacksonvilleServicesSection from "./components/ServicesSection";
import JacksonvilleLocalAreaSection from "./components/LocalAreaSection";
import JacksonvilleTestimonialsSection from "./components/TestimonialsSection";
import JacksonvilleAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import JacksonvilleComparisonSection from "./components/ComparisonSection";
import JacksonvilleMistakesSection from "./components/MistakesSection";
import JacksonvilleHowItWorksSection from "./components/HowItWorksSection";
import JacksonvilleFAQSection, { faqs } from "./components/FAQSection";
import JacksonvilleHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import JacksonvilleFinalCTA from "./components/FinalCTA";
import JacksonvilleTravelTimingSection from "./components/TravelTimingSection";
import JacksonvilleDestinationsSection from "./components/DestinationsSection";
import CitySEOHead from "@/components/feature/CitySEOHead";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

const faqsMapped = faqs.map((f: { q: string; a: string }) => ({ q: f.q, a: f.a }));

const servicesSchema = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Second Passport & Damaged", description: "Second passport issuance for frequent travelers and damaged passport replacement." },
];

export default function JacksonvillePage() {
  return (
    <div className="font-sans">
      <CitySEOHead
        city="Jacksonville"
        state="Florida"
        stateAbbr="FL"
        route="/cities/jacksonville"
        title="Emergency Passport Jacksonville, FL — Expedited & Fast Passport Service | Fast Passport Center"
        description="Emergency and expedited passport services in Jacksonville, FL — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Northeast Florida military families, business travelers, cruise passengers, and students."
        ogTitle="Emergency Passport Jacksonville, FL — Expedited & Fast Passport Service | Fast Passport Center"
        ogDescription="Emergency and expedited passport services in Jacksonville, FL — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Northeast Florida military families, business travelers, cruise passengers, and students."
        twitterTitle="Emergency Passport Jacksonville, FL — Expedited & Fast Passport Service | Fast Passport Center"
        twitterDescription="Emergency and expedited passport services in Jacksonville, FL — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Northeast Florida military families, business travelers, cruise passengers, and students."
        keywords="expedited passport Jacksonville, emergency passport Jacksonville FL, same day passport Jacksonville, fast passport Florida, passport renewal Jacksonville, Jacksonville passport courier"
        geoPlacename="Jacksonville, Florida"
        geoPosition="30.3322;-81.6557"
        faqs={faqsMapped}
        servicesSchema={servicesSchema}
        statePageName="Florida"
        statePageRoute="/states/florida"
      />
      <JacksonvilleHeroSection />
      <JacksonvilleStickyNav />
      <JacksonvilleProcessingTimeSection />
      <JacksonvilleLocalAreaSection />
      <JacksonvilleServicesSection />
      <JacksonvilleTravelTimingSection />
      <JacksonvilleDestinationsSection />
      <JacksonvilleTestimonialsSection />
      <JacksonvilleAcceptanceFacilitiesSection />
      <JacksonvilleComparisonSection />
      <JacksonvilleMistakesSection />
      <JacksonvilleHowItWorksSection />
      <JacksonvilleFAQSection />
      <JacksonvilleHelpfulResourcesSection />
      <SEOCrossLinks currentRoute="/jacksonville" state="FL" />
      <JacksonvilleFinalCTA />
    </div>
  );
}